import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { disableRestrictedAssetVisibility } from '@api/assetVisibility';

import { IId, IOrganizationId } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import {
	ASSET_VISIBILITY,
	ASSET_VISIBILITY_RESTRICTED,
	ASSET_VISIBILITY_RESTRICTED_DISABLE,
} from '@constants/queryKeys';

interface IUseMutateDisableAssetVisibilityReturned {
	disableAssetVisibility: UseMutateFunction<any, any, IId & Partial<IOrganizationId>, any>;
	isLoadingDisableAssetVisibility: boolean;
}

export const useMutateDisableAssetVisibility = (): IUseMutateDisableAssetVisibilityReturned => {
	const queryClient = useQueryClient();

	const {
		mutate,
		isLoading,
	} = useMutation<IId & Partial<IOrganizationId>>({
		mutationKey: [ASSET_VISIBILITY_RESTRICTED_DISABLE],
		allowedRoles: [
			EUserRoles.platformOwnerAdministrator,
			EUserRoles.assetOwnerOrganizationAdministrator,
		],
		mutationFn: disableRestrictedAssetVisibility,
		onSuccess: () => {
			return [
				queryClient.invalidateQueries([ASSET_VISIBILITY_RESTRICTED]),
				queryClient.invalidateQueries([ASSET_VISIBILITY]),
			];
		},
	});

	return {
		disableAssetVisibility: mutate,
		isLoadingDisableAssetVisibility: isLoading,
	};
};
